<h3 class="tray-header">Message Tray</h3>

<div class="tray-topbar">
  @if (userId) {
  <span class="user-info">User: {{ userId }}</span>
  }
  <input
    type="text"
    class="search-input"
    placeholder="Search logs..."
    [(ngModel)]="filterText"
    (input)="applyFilter()"
  />

  @if (ccn) {
    <span class="user-info">Center: {{ ccn }}</span>
  }
</div>

<div class="tabs">
  <span
    [class.active]="activeTab === 'ALL'"
    (click)="activeTab = 'ALL'; applyFilter()">
    All
  </span>

  <span
    [class.active]="activeTab === 'ERROR'"
    (click)="activeTab = 'ERROR'; applyFilter()">
    Errors
  </span>

  <span
    [class.active]="activeTab === 'INFO'"
    (click)="activeTab = 'INFO'; applyFilter()">
    Info
  </span>
</div>

<div class="messagetray-detail-card ">
  <div class="table-container">
    <table matSort
           matSortActive="timestamp"
           matSortDirection="desc"
           matSortDisableClear
           (matSortChange)="sortData($event)"
           class="table table-striped"
    >
      <thead>
      <tr>
        <th mat-sort-header="timestamp"> Timestamp </th>
        <th mat-sort-header="level" [disabled]="activeTab !== 'ALL' || !hasMultipleLevels()"> Level </th>
        <th> Message </th>
      </tr>
      </thead>

      <tbody>
      @for (data of filteredMessages; track data) {
        <tr
        [class.error-log]="data.logLevel === 'ERROR'"
        [class.info-log]="data.logLevel === 'INFO'"
        >
          <td class="timestamp">
            {{data.timestamp | date: "yyyy-MM-dd HH:mm:ssZ"}}
          </td>

          <td>
              {{data.logLevel }}
          </td>

          <td>
            <ngx-json-viewer [json]="data.message" [expanded]="false">  </ngx-json-viewer>
          </td>
      </tr>
      }
      </tbody>
    </table>

  </div>
</div>
